import { colorShade } from 'utils';

export const firstPageWrapper = {
  width: '100%',
  height: '100%',
  background: colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B'),
  display: 'flex',
  flexDirection: 'column',
};

export const titleWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginLeft: 50,
  marginRight: 50,
  paddingTop: 37,
  paddingBottom: 37,
  fontWeight: 500,
  fontSize: 32,
  color: window?.settings?.secondary_color ?? '#04333b',
  borderBottom: '1.5px solid #9EACB0'
}

export const filtersWrapper = {
  display: 'flex',
  alignItems: 'center',
  marginLeft: 50,
  marginRight: 50,
  paddingTop: 18,
  paddingBottom: 18,
  fontWeight: 500,
  fontSize: 15,
  color: window?.settings?.secondary_color ?? '#04333b',
  borderBottom: '1.5px solid #9EACB0'
}

export const assignationWrapper = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  marginLeft: 50,
  marginRight: 50,
  marginBottom: 30,
  paddingTop: 13,
  fontSize: 13,
  color: '#566F75',
}


export const tableWrapper = {
  background: '#FFFFFF',
  flexGrow: 1,
  width: '100%',
  borderTop: `1.5px solid ${colorShade(0.5, window?.settings?.primary_color ?? '#1DBD6B')}`,
  borderTopLeftRadius: 40,
  borderTopRightRadius: 40,
  paddingLeft: 50,
  paddingRight: 50,
}

export const pageTableWrapper = {
  background: '#FFFFFF',
  width: '100%',
  height: '100%',
  borderTop: `1.5px solid ${colorShade(0.5, window?.settings?.primary_color ?? '#1DBD6B')}`,
  borderTopLeftRadius: 40,
  borderTopRightRadius: 40,
  paddingLeft: 50,
  paddingRight: 50,
}

export const paginationWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginLeft: 50,
  paddingLeft: 20,
  paddingRight: 20,
  marginRight: 50,
  background: colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B'),
  borderRadius: 30,
  height: 35,
  marginTop: 35,
  fontSize: 12,
  color: 'black',
}

export const inspectionRowWrapper = {
  borderBottom: '1.5px solid #9EACB0',
  height: 60,
  fontSize: 13,
  color: window?.settings?.secondary_color ?? '#04333b'
}

export const tableStyle = {
  width: '100%',
  marginTop: 30,
}

export const templateName = {
  fontWeight: 600,
}

export const unitName = {
  fontSize: 11,
  color: '#9BADB1'
}

export const thStyle = {
  textAlign: 'left'
}

export const tHeadStyle = {
  fontSize: 12,
  color: '#9EACB0',
  fontWeight: 500,
  borderBottom: '1.5px solid #9EACB0',
  height: 50,
  textAlign: 'left'
}

export const linkStyle = {
  fontSize: 13,
  color: window?.settings?.primary_color ?? '#1DBD6B',
  textDecoration: 'underline',
  cursor: 'pointer'
}

export const progressBarWrapper = {
  width: 100,
  background: '#F3F5F5',
  height: 13,
  borderRadius: 60,
  position: 'relative',
  display: 'flex',
  justifyContent: 'flex-start'
}